export default class StateMachine {
    constructor(config) {
        const setOfAllStates = new Set();
        const setOfAllTransitions = new Set();
        const emptySet = new Set()


        // string => string
        const stateByTransition = Object.create(null)

        // string => Set<string>
        const transitionsAllowedFromCurrentState = Object.create(null)
        // string => Set<string>
        const possibleStatesToEnterCurrentStateFrom = Object.create(null)
        // string => Set<string>
        const possibleStatesFromCurrentState = Object.create(null)

        function addPossibleStateFrom(from, to, name) {
            if (!possibleStatesFromCurrentState[from]) {
                possibleStatesFromCurrentState[from] = new Set()
            }
            possibleStatesFromCurrentState[from].add(to)

            if (!transitionsAllowedFromCurrentState[from]) {
                transitionsAllowedFromCurrentState[from] = new Set()
            }
            transitionsAllowedFromCurrentState[from].add(name)
        }

        for (let item of config.transitions) {
            setOfAllStates.add(item.to)
            setOfAllTransitions.add(item.name)
            stateByTransition[item.name] = item.to
            let fromStates = typeof item.from === 'string' ? [item.from] : item.from
            possibleStatesToEnterCurrentStateFrom[item.to] = new Set(fromStates)
            for (let state of fromStates) {
                addPossibleStateFrom(state, item.to, item.name)
            }
        }


        if (!setOfAllStates.has(config.init)) {
            throw new Error("Invalid init state!")
        }


        this.config = config
        this.currentState = this.config.init
        this.setOfAllStates = setOfAllStates
        this.setOfAllTransitions = setOfAllTransitions
        this.stateByTransition = stateByTransition
        this.possibleStatesFromCurrentState = possibleStatesFromCurrentState
        this.possibleStatesToEnterCurrentStateFrom = possibleStatesToEnterCurrentStateFrom
        this.transitionsAllowedFromCurrentState = transitionsAllowedFromCurrentState

        
        // string => function
        const callbacks = Object.create(null)
        Object.keys(config.methods).forEach(key => {
            callbacks[ key.slice(2).toLowerCase() ] = config.methods[ key ]
        })

        this.callbacks = callbacks

        // call initial state callback
        this.attemptTransition(null, true)
        this.emptySet = emptySet
    }

    transitions = () => {
        return this.transitionsAllowedFromCurrentState[this.currentState] || this.emptySet
    }
    can = (t) => {
        // console.log(`can(${t})`)
        return (this.transitionsAllowedFromCurrentState[this.currentState] || this.emptySet).has(t) || (this.possibleStatesToEnterCurrentStateFrom[this.stateByTransition[t]] || this.emptySet).has('*')
    }
    is = (s) => {
        return this.currentState === s
    }

    // attempt transition to
    attemptTransition = (t, init=false) => {
        // console.log(`attemptTransition(${t})`)
        if (!init && !this.can(t)) {
            console.log(`Cannot ${t}`)
            return;
        }
        let lifecycle;
        if (init) {
            lifecycle = {transition: 'init', from: 'none', to: this.currentState}
        } else {
            lifecycle = {transition: t, from: this.currentState, to: this.stateByTransition[t]}
        } 
        this.currentState = lifecycle.to
        this.callbacks['enterstate'] && this.callbacks['enterstate'](lifecycle)
        this.callbacks[t] && this.callbacks[t](lifecycle)
        // this.callbacks['leavestate'] && this.callbacks['leavestate'](lifecycle)
    }
}